/**
 * Max width for NfcPrintThemeCanvas in gallery tiles so scaled artboard height
 * fits previewMaxHeightPx (avoids clipping / uneven card heights).
 */
export function galleryFitMaxWidthForTheme(themeJson, previewMaxHeightPx = 226) {
  const pw = Number(themeJson?.canvas?.width) || 2102;
  const ph = Number(themeJson?.canvas?.height) || 1346;
  const off = Number(themeJson?.canvas?.offsetTop) || 0;
  const artH = Math.max(1, ph + off);
  const w = Math.floor((previewMaxHeightPx * pw) / artH);
  return Math.min(400, Math.max(200, w));
}
